this.RGBColor=RGBColor;
